module.exports = __webpack_public_path__ + "static/img/gp.e3d8fe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/info/gp.png
// module id = 9AYW
// module chunks = 1